import { createTeleTechnicianWorkApiClient } from "../ApiClientFactory";
import { genericErrorMessage } from "../serviceNowLink";

export const toggleErrorFileLinesHandled = async (obj: { id: string, handled: boolean }) => {
  try {
    await createTeleTechnicianWorkApiClient().errorFileLines.putApiErrorFileLinesToggleHandled(obj.id, obj.handled);
  } catch (err) {
    throw new Error(`Fejlen kunne ikke markeres som håndteret. ${genericErrorMessage}`);
  }
};